import { Dropdown } from 'primereact/dropdown';
import React from 'react';

export interface RecipientDropdownProps { 
    recipientList: any;
    selectedRecipient: any;
    handleRecipientChange: (e:any)=>void;   
}

export const RecipientDropdown = ({ recipientList, selectedRecipient, handleRecipientChange }: RecipientDropdownProps) => {
    return (
        <div className="content">
            <label htmlFor="select-recipient">Select Recipient</label>
            <Dropdown
                id="select-recipient"
                filter
                placeholder="Select Recipient"
                className="custom-dropdown"
                options={recipientList}
                optionValue={'employeeNumber'}
                optionLabel={'employeeName'}
                value={selectedRecipient?.employeeNumber}
                onChange={(e) => { handleRecipientChange(e); }}
            />
        </div>
    );
};
